import { library, dom } from '@fortawesome/fontawesome-svg-core'
import {
  faInfoCircle,
  faCogs,
  faCog,
  faPen,
  faPlus,
  faTimes,
  faCaretRight,
  faCaretLeft,
  faChevronUp,
  faArrowUp,
  faArrowDown,
  faChevronRight,
  faChevronLeft,
  faCalendarCheck,
  faSyncAlt,
  faExclamationCircle,
  faEraser,
  faSignOutAlt,
  faArrowAltCircleRight,
  faTerminal,
  faCalendarWeek,
  faList,
  faToolbox,
  faClock as fasClock,
  faBolt,
  faUser,
} from '@fortawesome/free-solid-svg-icons'

import { faTrashAlt, faClock, faCalendarAlt, faEyeSlash } from '@fortawesome/free-regular-svg-icons'

library.add(
  faInfoCircle,
  faCogs,
  faCog,
  faPen,
  faPlus,
  faTimes,
  faCaretRight,
  faCaretLeft,
  faChevronUp,
  faChevronRight,
  faChevronLeft,
  faArrowUp,
  faArrowDown,
  faTrashAlt,
  faClock,
  fasClock,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarWeek,
  faSyncAlt,
  faExclamationCircle,
  faEraser,
  faSignOutAlt,
  faArrowAltCircleRight,
  faEyeSlash,
  faTerminal,
  faList,
  faToolbox,
  faBolt,
  faUser,
)
dom.watch()
